import $ from 'jquery';
import React from 'react';

import FocusTrap from 'focus-trap-react';

import noop from 'lodash/noop';

import BaseModal from 'zoomforth_component_lib/base_modal.jsx';
import Button from 'zoomforth_component_lib/btn_basic.jsx';

export const PrivacyPolicyLink = ({ url })=> (
  <a href={url} className="zf-external-link" target="_blank">
    Privacy Policy
    <span className="opens-in-external-view-wrapper">
      Opens in a new window
    </span>
  </a>
);

const InitialConsentModal = ({ privacyPolicyUrl, onAllowAllClick, onManagePreferencesClick })=> (
  <FocusTrap>
    <BaseModal
      show={true}
      closeOnOuterClick={false}
      className="consent-modal initial-consent-modal"
      onRequestClose={noop}
    >
      <h1>Privacy preferences</h1>

      <div className="consent-copy">
        <p>
          This website uses cookies and tracking data to provide a personalized
          browsing experience and necessary site functionality. Do you agree to
          the use of cookies and data tracking as outlined in our <PrivacyPolicyLink url={privacyPolicyUrl} /> ?
        </p>
      </div>

      <div className="consent-options">
        <Button
          primary
          className="accept-btn"
          tellRef={(ref)=> {
            $(ref).focus();
          }}
          onClick={onAllowAllClick}
        >
          Yes, I accept
        </Button>

        <Button className="manage-choices-link" onClick={onManagePreferencesClick}>
          Manage choices
        </Button>
      </div>
    </BaseModal>
  </FocusTrap>
);

export default InitialConsentModal;
